<template>
  <main>
    <div class=" mb-2">
      <div class="col-12">
        <h4 class="text-primary font-weight-bold mb-1">
          <i class="feather icon-book-open mr-2"></i>Educaciones Médicas
        </h4>
      </div>
    </div>

    <!-- Active view (when history is editable) -->
    <div v-if="finalizada === 'N'">
      <div v-if="educaciones.length === 0" class="alert alert-warning py-3 rounded-lg shadow-sm border-0 d-flex align-items-center">
        <i class="feather icon-alert-triangle mr-3 font-medium-3"></i>
        <span>No hay educaciones configuradas para este tipo de historia clínica.</span>
      </div>
      <div v-else>
        <div 
          v-for="item in educaciones" 
          :key="item.id_educacion" 
          class="card mb-2 border-0 rounded-lg shadow-none "
        >
          <div class="card-body p-3">
            <div class="form-group mb-0">
              <label class="font-weight-bold text-gray-700 mb-2 ">
                <i class="feather icon-book-open mr-2 text-gray-700 font-weight-bold"></i>{{ item.nombre }}
              </label>
              <textarea
                rows="7"
                class="form-control border-gray rounded-sm textarea-educacion"
                v-model="item.texto"
                :placeholder="'Escribe la educación para ' + item.nombre"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Read-only view (when history is finalized) -->
    <div v-else>
      <div v-if="educaciones.filter(x => x.texto && x.texto.trim() !== '').length === 0" class="alert alert-info py-3 rounded-lg shadow-sm border-0 d-flex align-items-center">
        <i class="feather icon-info mr-3 font-medium-3"></i>
        <span>No se registraron educaciones para esta historia.</span>
      </div>
      <div v-else>
        <div 
          v-for="item in educaciones.filter(x => x.texto && x.texto.trim() !== '')" 
          :key="item.id_educacion" 
          class="card mb-3 border-0 border-left-primary rounded-lg shadow-sm"
        >
          <div class="card-body py-3 px-4">
            <h5 class="card-title font-weight-bold text-primary mb-2">
              <i class="feather icon-check-circle mr-2 text-success"></i>{{ item.nombre }}
            </h5>
            <p class="card-text text-gray-700 whitespace-pre-line pl-4 font-medium-1">
              {{ item.texto }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Toast from "@/components/common/utilities/toast";
import educacionService from "@/services/educacionService";
import historiaEducacionService from "@/services/historiaEducacionService";

export default {
  props: {
    idHistoria: {
      type: [String, Number],
      required: true
    },
    finalizada: {
      type: String,
      required: true
    },
    idUsuario: {
      type: [String, Number],
      required: false
    },
    usuario: {
      type: Object,
      required: false
    },
    codigo: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      educaciones: []
    };
  },
  methods: {
    async cargar() {
      try {
        const response = await educacionService.showByCodigo(this.codigo);
        
        // Map all configured educations
        const allEducations = response.data.map(x => ({
          id_educacion: x.id,
          nombre: x.nombre,
          default_text: x.default_text || '',
          texto: x.default_text || ''
        }));

        // Load saved records for this history
        if (this.idHistoria) {
          const savedResponse = await historiaEducacionService.showByHc(this.idHistoria);
          
          if (savedResponse.data && savedResponse.data.length > 0) {
            savedResponse.data.forEach(savedItem => {
              const found = allEducations.find(x => x.id_educacion === savedItem.id_educacion);
              if (found) {
                found.texto = savedItem.texto;
              }
            });
          }
        }
        
        this.educaciones = allEducations;
      } catch (e) {
        console.error("Error al cargar educaciones:", e);
      }
    },
    async save() {
      if (this.finalizada !== 'N') return;
      try {
        this.LoaderSpinnerShow();

        const payload = {
          id_historia: this.idHistoria,
          educaciones: this.educaciones
            .filter(x => x.texto && x.texto.trim() !== '')
            .map(x => ({
              id_educacion: x.id_educacion,
              texto: x.texto
            }))
        };

        await historiaEducacionService.store(payload);

        this.LoaderSpinnerHide();

        Toast.fire({
          icon: 'success',
          title: 'Educaciones guardadas con éxito'
        });
      } catch (e) {
        console.error(e);
        this.LoaderSpinnerHide();
        Toast.fire({
          icon: 'error',
          title: 'Ha ocurrido un error al guardar las educaciones'
        });
      }
    }
  },
  watch: {
    finalizada: {
      immediate: true,
      handler: async function (value) {
        if (value) {
          await this.cargar();
        }
      }
    }
  }
};
</script>

<style scoped>
.base-educaciones-container {
  padding: 10px 5px;
}
.education-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.education-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05) !important;
}
.border-left-primary {
  border-left: 4px solid #4e73df !important;
}
.border-gray {
  border: 1px solid #d1d3e2 !important;
}
.label-educacion {
  font-size: 1.05rem;
}
.textarea-educacion {
  font-size: 0.95rem;
  line-height: 1.5;
  resize: vertical;
}
.whitespace-pre-line {
  white-space: pre-line;
}
</style>
